import React from 'react'
import Videos from '/data/videos'
import Images from '/data/images'
import { isTablet } from '/js/util'

class Video extends React.Component {
  render() {
    const { bgVideo } = this.props

    if (!bgVideo) {
      return null
    }

    return (
      <div className="overlay-video">
        <video
          className="absolute top-0 left-0 w-full h-full object-cover -z-1"
          autoPlay={isTablet() ? false : true}
          muted={true}
          loop={true}
          poster={Images[bgVideo.images.key].defaultRes}
        >
          {/* <source src={Videos[bgVideo.key].webm} type="video/webm" /> */}
          <source src={Videos[bgVideo.key].mp4} type="video/mp4" />
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
    )
  }
}

export default Video
